import { errorCode, rateLimitedMessage } from '@infrastructure/admin-security-api';
import { securityMessage } from '../admin/settings/access/SecurityParts';
// Backend codes of the MCP portal endpoints (QPortal.Backend.Mcp McpConsentService / McpConnectionService). Admin-security
// codes (STEP_UP_REQUIRED, STRONG_SESSION_REQUIRED, SESSION_INVALID, FORBIDDEN, ...) and RATE_LIMITED with
// retryAfterSeconds reuse the existing admin-security mapping.
const mcpMessages = {
    MCP_CONSENT_NOT_FOUND: 'This connection request is not available. It may already have been used. Start connecting again from the app.',
    MCP_CONSENT_EXPIRED: 'This connection request expired. Start connecting again from the app.',
    MCP_CONSENT_ALREADY_DECIDED: 'This connection request was already answered. Start connecting again from the app if you still want to connect it.',
    MCP_NOT_ELIGIBLE: 'Your account cannot connect this app.',
    MCP_SCOPE_INVALID: 'Choose from the requested permissions. Read access is always needed.',
    MCP_ADMIN_SECURITY_NOT_ENFORCED: 'Admin connections are only possible when passkey or authenticator sign-in is required for this portal.',
    MCP_CONNECTION_NOT_FOUND: 'This connection is no longer active. The list has been reloaded.',
    ADMIN_SECURITY_DISABLED: 'This needs passkey or authenticator sign-in, which is not yet available for this portal.',
    STEP_UP_PURPOSE_INVALID: 'This confirmation is not available. Reload the page and try again.',
    MCP_DECISION_RETRY: 'QPortal was busy with another confirmation at the same moment. Nothing was changed. Confirm again.'
};
export const mcpMessage = (error) => {
    const code = errorCode(error);
    if (code === 'RATE_LIMITED')
        return rateLimitedMessage(error);
    return mcpMessages[code] ?? securityMessage(error);
};
// With the kill switch off (Mcp:Enabled=false) the MCP routes do not exist: a 404 without a backend code.
export const connectorsSwitchedOff = (error) => error?.response?.status === 404 && errorCode(error) === 'REQUEST_FAILED';
const scopeTitles = {
    'hours:read': 'View your hours',
    'hours:draft': 'Save hours as a draft',
    'admin:read': 'View admin information',
    'admin:approve': 'Prepare approvals and rejections',
    'admin:mail': 'Prepare e-mails (you confirm each one in QPortal)'
};
export const scopeTitle = (scope) => scopeTitles[scope] ?? scope;
export { formatDateTime } from '../admin/settings/access/SecurityParts';
